import * as React from "react";
import cx from "classnames";

const getInputClass = ({ type = "", meta }): string =>
  cx("form-control__input", "form-control__placeholder-input", {
    "text-center": type === "number",
    "has-error": meta.touched && meta.error,
  });

const TextInput = ({
  className,
  disabled,
  placeholder,
  input,
  meta,
  ...props,
}) =>
  <div className={className}>
    <input
      className={getInputClass({ meta, ...props })}
      disabled={disabled}
      placeholder={placeholder}
      {...input}
      {...props}
    />
    {meta.touched &&
      meta.error &&
      <span className="form-control__error">
        {meta.error}
      </span>}
  </div>;

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/TextInput.tsx